/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IContractsRenewalViewProps } from './contracts-renewal';
import { Module } from '@msdyn365-commerce-modules/utilities';

export default (props: IContractsRenewalViewProps) => {
    const { contractsHeading, contractsWrapper, contractsBeforeText, contractsTable, contractsAfterText, contractsLinks } = props;
    return (
        <Module {...contractsWrapper}>
            {contractsHeading}
            {contractsBeforeText}
            {contractsTable}
            {contractsAfterText}
            {contractsLinks}
        </Module>
    );
};
